import { useContext } from 'react'

import { RequestProfileTabActivitiesContext } from '../../RequestProfileTabActivities.context'

export function useRequestProfileTabActivitiesContext() {
  return useContext(RequestProfileTabActivitiesContext)
}
